import * as z from 'zod';
import { classificationPredictionSchema, fileTypeSchema } from '../../enums.mjs';
import { fileId } from '../../types/opaque.mjs';
import { ApplicationExtractionWebhookPayload } from '../../types/surety/application-extraction/application-extraction-webhook.mjs';
import { BondRequestExtractionWebhookPayload } from '../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import { ContractExtractionResultPayload, ContractExtractionFailurePayload, ContractExtractionWebhookPayload } from '../../types/surety/contract/contract-extraction-webhook.mjs';
import { ExtractionResultPayload, ExtractionFailurePayload } from '../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import { ExtractionResultPayload as ExtractionResultPayload$1, ExtractionFailurePayload as ExtractionFailurePayload$1 } from '../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';

const classificationCompletedPayloadSchema = z.object({
    type: z.literal("classification"),
    fileId: fileId,
    status: z.literal("completed"),
    tags: z.array(fileTypeSchema),
    prediction: classificationPredictionSchema.optional(),
});
const classificationFailedPayloadSchema = z.object({
    type: z.literal("classification"),
    fileId: fileId,
    status: z.literal("failed"),
    tags: z.array(fileTypeSchema),
    error: z.string().optional(),
});
const classificationPayloadSchema = z.discriminatedUnion("status", [
    classificationCompletedPayloadSchema,
    classificationFailedPayloadSchema,
]);
const financialExtractionPayloadSchema = z.discriminatedUnion("status", [
    ExtractionResultPayload.schema.extend({ type: z.literal("financial-extraction") }),
    ExtractionFailurePayload.schema.extend({ type: z.literal("financial-extraction") }),
]);
const contractExtractionPayloadSchema = z.discriminatedUnion("status", [
    ContractExtractionResultPayload.schema.extend({ type: z.literal("contract-extraction") }),
    ContractExtractionFailurePayload.schema.extend({ type: z.literal("contract-extraction") }),
]);
const wipScheduleExtractionPayloadSchema = z.discriminatedUnion("status", [
    ExtractionResultPayload$1.schema.extend({
        type: z.literal("wip-schedule-extraction"),
    }),
    ExtractionFailurePayload$1.schema.extend({
        type: z.literal("wip-schedule-extraction"),
    }),
]);
const applicationExtractionPayloadSchema = ApplicationExtractionWebhookPayload.schema.and(z.object({ type: z.literal("application-extraction") }));
const bondRequestExtractionPayloadSchema = BondRequestExtractionWebhookPayload.schema.and(z.object({ type: z.literal("bond-request-extraction") }));
const contractV2ExtractionPayloadSchema = z.object({
    type: z.literal("contract-v2-extraction"),
    contract: ContractExtractionWebhookPayload.schema,
    bondRequest: BondRequestExtractionWebhookPayload.schema.optional(),
});
var Webhook;
(function (Webhook) {
    Webhook.schema = z.union([
        classificationPayloadSchema,
        financialExtractionPayloadSchema,
        contractExtractionPayloadSchema,
        contractV2ExtractionPayloadSchema,
        applicationExtractionPayloadSchema,
        bondRequestExtractionPayloadSchema,
        wipScheduleExtractionPayloadSchema,
    ]);
})(Webhook || (Webhook = {}));

export { Webhook };
